<div class="toolbar-wrapper flex justify-end items-center z-depth-1">
  <y42-orchestration-node-status-filter *ngIf="!state.isDiagramEditable" class="mx-3" [diagram]="diagram">
  </y42-orchestration-node-status-filter>
  <button
    mat-icon-button
    class="generic-settings-btn"
    matTooltip="Align Nodes"
    (click)="alignNodes()"
    [intercomTarget]="'01-dag-gojs-57732'"
    [disabled]="false"
  >
    <fa-icon class="fs-09" [icon]="['fal', 'align-left']"></fa-icon>
  </button>

  <button
    mat-icon-button
    class="generic-settings-btn"
    (click)="exportJson(downloadLink)"
    [disabled]="!state.diagramHasValidNodes"
    [matTooltip]="'Download DAG File'"
    [intercomTarget]="'orchestration-export-button'"
  >
    <fa-icon class="fs-09" *ngIf="!state.exportLoader" [icon]="['fal', 'download']"> </fa-icon>
    <mat-spinner *ngIf="state.exportLoader" [color]="'primary'" class="mx-1 spinner" [diameter]="23"> </mat-spinner>
  </button>

  <a href="void;" #downloadLink id="downloadElem" [hidden]="true">.</a>

  <button
    *ngIf="state.isDiagramEditable"
    mat-icon-button
    class="generic-settings-btn"
    (click)="fileInputRef.click()"
    [matTooltip]="'Import DAG File'"
    [intercomTarget]="'orchestration-import-button'"
  >
    <fa-icon class="fs-09" *ngIf="!state.importLoader" [icon]="['fal', 'upload']"> </fa-icon>
    <mat-spinner *ngIf="state.importLoader" [color]="'primary'" class="mx-1 spinner" [diameter]="23"> </mat-spinner>
  </button>
  <input #fileInputRef type="file" accept="application/json" [hidden]="true" (change)="importJson($event)" />

  <button
    mat-icon-button
    class="generic-settings-btn"
    (click)="undo()"
    matTooltip="Undo"
    [disabled]="state.isUndoButtonDisabled || !state.canUndo"
    [matBadgeHidden]="state.undoCount < 1"
    [matBadge]="state.undoCount"
    matBadgeSize="small"
    matBadgePosition="after"
    [intercomTarget]="'orchestration-undo-button'"
  >
    <fa-icon class="fs-09" [icon]="['fal', 'undo']"></fa-icon>
  </button>

  <button
    mat-icon-button
    class="generic-settings-btn"
    (click)="redo()"
    matTooltip="Redo"
    [disabled]="state.isRedoButtonDisabled || !state.canRedo"
    [matBadgeHidden]="state.redoCount < 1"
    [matBadge]="state.redoCount"
    matBadgeSize="small"
    matBadgePosition="before"
    [intercomTarget]="'orchestration-redo-button'"
  >
    <fa-icon class="fs-09" [icon]="['fal', 'redo']"></fa-icon>
  </button>

  <button
    mat-icon-button
    class="generic-settings-btn mr-3"
    [disabled]="!state.diagramHasValidNodes"
    (click)="searchOrchestrationNodes()"
    [matTooltip]="'Search Orchestration'"
    [intercomTarget]="'orchestration-search-button'"
  >
    <fa-icon class="fs-09" [icon]="['fal', 'search']"></fa-icon>
  </button>

  <button
    *ngIf="state.isDiagramEditable"
    mat-raised-button
    matTooltip="Add Nodes"
    (click)="addNodesToOrchestration()"
    [intercomTarget]="'add-orchestration-nodes'"
    class="add-nodes-button"
    data-test="orchestration-add-button-add-nodes"
  >
    <fa-icon class="mr-2 fs-1 text-white" [icon]="['fal', 'plus']"></fa-icon>
    <span> Add Nodes </span>
  </button>
</div>
